export const KeyTakeaways = ({ items, label }: { items: string[]; label: string }) => {
  if (!items.length) return null;
  return (
    <section data-testid="key-takeaways" data-track="key_takeaways"
      className="relative overflow-hidden rounded-xl border border-white/[0.09] bg-white/[0.02] p-5 sm:p-6">
      <span aria-hidden className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-[#00E5FF]/60 via-[#34D399]/40 to-transparent" />
      <p className="font-mono text-[10px] font-bold uppercase tracking-[0.3em] text-[#00E5FF]">{label}</p>
      <ul className="mt-3.5 space-y-2.5">
        {items.map((k, i) => (
          <li key={i} className="flex gap-3 text-[15px] text-gray-200 leading-relaxed">
            <span aria-hidden className="mt-[9px] h-1.5 w-1.5 shrink-0 rounded-full bg-gradient-to-br from-[#00E5FF] to-[#34D399]" />
            {k}
          </li>
        ))}
      </ul>
    </section>
  );
};
